const INITIAL_STATE = {
  items: [],
  didInvalidate: true,
  fetchingInProgressSince: null,
  lastSuccessfulFetch: null,
  lastFailedFetch: null,
  lastErrorMessage: null,
  lastPaymentMethod: null,
  lastBundleAmount: null,
};

// eslint-disable-next-line complexity
module.exports = function PurchasesReducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case 'LOGOUT_SUCCESSFUL':
      return INITIAL_STATE;
    case 'SET_API_URL':
      return INITIAL_STATE;
    case 'INVALIDATE_PURCHASES':
    case 'SET_LANGUAGE':
      return {
        ...state,
        didInvalidate: true,
      };
    case 'FETCH_PURCHASES_IN_PROGRESS': {
      return {
        ...state,
        fetchingInProgressSince: action.timestamp,
      };
    }
    case 'FETCH_PURCHASES_SUCCESSFUL': {
      const alreadySeen = {};
      if (state && state.items) {
        state.items.forEach((item) => {
          alreadySeen[item._id] = item.seen;
        });
      }

      return {
        ...state,
        didInvalidate: false,
        fetchingInProgressSince: null,
        lastSuccessfulFetch: action.timestamp,
        items: action.purchases.map((purchase) => ({
          ...purchase,
          seen: alreadySeen[purchase._id],
        })),
      };
    }
    case 'FETCH_PURCHASES_FAILED':
      return {
        ...state,
        fetchingInProgressSince: null,
        lastFailedFetch: action.timestamp,
        lastErrorMessage: action.reason,
      };
    case 'ADD_PURCHASE':
    case 'UPDATE_PURCHASE': {
      if (!action.purchase || !action.purchase._id) {
        return state;
      }
      const { purchases, ...purchase } = action.purchase;
      let { items } = state;

      if (Array.isArray(purchases)) {
        purchases.push(purchase);
        purchases.forEach((p) => {
          const found = state.items.find((item) => item._id === p._id);
          items = found
            ? items.map((item) => (item._id === p._id ? p : item))
            : [...items, p];
        });
      } else {
        const found = items.find((item) => item._id === action.purchase._id);
        items = found
          ? items.map((item) =>
              item._id === action.purchase._id ? action.purchase : item,
            )
          : [...items, action.purchase];
      }

      return {
        ...state,
        lastSuccessfulFetch: action.timestamp,
        items,
      };
    }
    case 'ADD_PURCHASES': {
      const purchases = (action.purchases || []).filter((p) => p._id);
      if (!purchases.length) {
        return state;
      }
      const changed = [];
      const items = state.items.map((item) => {
        const purchase = purchases.find((p) => p._id === item._id);
        if (purchase) {
          changed.push(purchase);
          return purchase;
        }
        return item;
      });

      return {
        ...state,
        items: [
          ...items,
          ...purchases.filter((p) => !changed.find((c) => c._id === p._id)),
        ],
        didInvalidate: true,
      };
    }
    case 'PURCHASE_LOOT_SUCCESSFUL':
      return {
        ...state,
        items: [...state.items, action.purchase],
      };
    case 'OPEN_PURCHASE_SUCCESSFUL':
      return {
        ...state,
        items: state.items.map((purchase) => {
          if (purchase._id !== action.purchaseId) {
            return purchase;
          }

          return {
            ...purchase,
            opened: action.timestamp,
          };
        }),
      };
    case 'SET_CARDS_SEEN':
      return {
        ...state,
        items: state.items.map((purchase) => {
          if (purchase._id !== action.purchaseId) {
            return purchase;
          }

          return {
            ...purchase,
            seen: action.timestamp,
          };
        }),
      };
    case 'SET_PAYMENT_METHOD':
      return {
        ...state,
        lastPaymentMethod: action.paymentMethod,
      };
    case 'SET_LAST_BUNDLE_AMOUNT':
      return {
        ...state,
        lastBundleAmount: action.bundleAmount,
      };
    default:
      return state;
  }
};
